var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInviteSentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124.453,
    height: 71.064,
    viewBox: "0 0 124.453 71.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Done",
    transform: "translate(-17 -43.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M43.5,104.332H95.936a4.066,4.066,0,0,0,.864-.093,4.066,4.066,0,0,0,.864.093h29.961a4.033,4.033,0,1,0,0-8.066h-3.457a4.033,4.033,0,0,1,0-8.066h10.947a4.033,4.033,0,1,0,0-8.066H122.439a4.033,4.033,0,1,0,0-8.066H85.564a4.033,4.033,0,1,0,0-8.066H52.723a4.033,4.033,0,0,0,0,8.066H29.676a4.033,4.033,0,0,0,0,8.066h14.4a4.033,4.033,0,1,1,0,8.066H21.033a4.033,4.033,0,1,0,0,8.066H43.5a4.033,4.033,0,1,0,0,8.066Zm93.916,0a4.033,4.033,0,1,0-4.033-4.033A4.033,4.033,0,0,0,137.42,104.332Z",
    transform: "translate(0 -8.053)",
    fill: "#f3f7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M172.5,45v3.457",
    transform: "translate(-65.905)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M172.5,59v3.457",
    transform: "translate(-65.905 -5.934)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M162.5,55h3.457",
    transform: "translate(-61.667 -4.238)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M176.5,55h3.457",
    transform: "translate(-67.601 -4.238)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M89.5,148v2.3",
    transform: "translate(-30.728 -43.654)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M89.5,160v2.3",
    transform: "translate(-30.728 -48.74)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M81.5,156h2.3",
    transform: "translate(-27.337 -47.045)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M93.5,156h2.3",
    transform: "translate(-32.423 -47.045)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M126.08,99.285a26.218,26.218,0,0,0,5.2-10.5A26.6,26.6,0,0,0,99.11,56.756,26.357,26.357,0,0,0,79.482,77.369a26.594,26.594,0,0,0,28.594,31.523,26.344,26.344,0,0,0,10.311-3.175",
    transform: "translate(-26.277 -4.662)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M126.08,99.285a26.218,26.218,0,0,0,5.2-10.5A26.6,26.6,0,0,0,99.11,56.756,26.357,26.357,0,0,0,79.482,77.369a26.594,26.594,0,0,0,28.594,31.523,26.344,26.344,0,0,0,10.311-3.175",
    transform: "translate(-26.277 -4.662)",
    fill: "none",
    stroke: "#1f64e7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M150.7,137.8a21.125,21.125,0,0,0,4.132-3.507Z",
    transform: "translate(-56.666 -37.844)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M150.7,137.8a21.125,21.125,0,0,0,4.132-3.507",
    transform: "translate(-56.666 -37.844)",
    fill: "none",
    stroke: "#1f64e7",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M131.4,85.707q-.247,0-.5,0A27.589,27.589,0,0,1,103.44,60,24.339,24.339,0,1,0,131.4,85.707Z",
    transform: "translate(-27.973 -6.357)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M106.894,95.129a1.715,1.715,0,0,0-2.442.112,1.76,1.76,0,0,0,.111,2.468l8.135,7.512a2.4,2.4,0,0,0,3.418-.156c.038-.043.038-.043.074-.086L127.8,90.865a1.761,1.761,0,0,0-.224-2.461,1.716,1.716,0,0,0-2.434.226L114.227,101.9Z",
    transform: "translate(-36.873 -18.225)",
    fill: "#fff",
    stroke: "#1f64e7",
    strokeLinecap: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M101.282,64.413a22.982,22.982,0,0,0-7.913,5.008,23.341,23.341,0,0,0-1.645,1.761M90.14,73.3q-.611.923-1.124,1.89-.379.713-.705,1.447",
    transform: "translate(-30.223 -8.228)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M101.005,64.558a.72.72,0,0,0-.506-1.349Zm-3.535.863.356.626Zm-4.631,3.471-.5-.518Zm-2.2,1.3a.72.72,0,0,0,1.1.927Zm-.433,2.98a.72.72,0,1,0-1.2-.795ZM88.486,74.66l.636.338h0Zm-1.363,1.154a.72.72,0,1,0,1.316.585ZM100.5,63.209a23.639,23.639,0,0,0-3.385,1.585l.712,1.252a22.21,22.21,0,0,1,3.179-1.489Zm-3.385,1.585a23.833,23.833,0,0,0-4.776,3.579l1,1.036a22.4,22.4,0,0,1,4.487-3.363Zm-4.776,3.579a24.06,24.06,0,0,0-1.7,1.815l1.1.927a22.609,22.609,0,0,1,1.594-1.707Zm-3.33,4q-.63.952-1.159,1.949L89.122,75q.5-.935,1.089-1.83ZM87.85,74.322q-.391.736-.727,1.492l1.316.585q.316-.71.683-1.4Z",
    transform: "translate(-29.693 -7.698)",
    fill: "#75a4fe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteSentIcon);
export default __webpack_public_path__ + "static/media/invite-sent-icon.26bd48dacaa3e7340b403cb52d3c7057.svg";
export { ForwardRef as ReactComponent };